/**
 * 受注一覧
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const driver_schedule_schedule = {
  namespaced: true,
  actions: {
    /**
     * 配車計画 受注一覧
     * @param commit
     * @param target_date
     * @returns {Promise<unknown>}
     */
    index ({ commit }, { target_date }) {
      const params = { target_date: target_date }
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/driver_schedules/schedules`, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { target_date, driver_id }) {
      const params = { target_date: target_date, driver_id: driver_id }
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/driver_schedules/schedule`, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 左ペインからのドロップ処理
     * @param commit
     * @param target_date { String } 対象日
     * @param driver_id { Number } ドライバーID
     * @param order_id { Number } 追加する受注番号
     * @param sorted_schedules { Array } 一覧の並びで格納した受注ID
     * @returns {Promise<unknown>}
     */
    create ({ commit }, { target_date, driver_id, order_id, sorted_schedules }) {
      const params = { target_date: target_date, driver_id: driver_id, order_id: order_id, sorted_schedules: sorted_schedules }
      return new Promise((resolve) => {
        Vue.$http.post(`${httpConst.DRIVER_ENDPOINT}/driver_schedules/schedule`, params).then(data => {
          commit('snackbar/showInfo', { message: '追加しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    destroy ({ commit }, { driver_schedule_id, driver_schedule_detail_id }) {
      return new Promise((resolve) => {
        Vue.$http.delete(`${httpConst.DRIVER_ENDPOINT}/driver_schedules/${driver_schedule_id}/schedules/${driver_schedule_detail_id}`).then(data => {
          commit('snackbar/showInfo', { message: '解除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
}
export default driver_schedule_schedule
